export function initCounters() {
    const counters = document.querySelectorAll('.counter');

    const observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
            if (!entry.isIntersecting) {
                continue;
            }

            initCounter(entry.target);

            observer.unobserve(entry.target);
        }
    }, {
        threshold: 1,
    });
    for (const counter of counters) {
        const items = counter.querySelectorAll('.counter-item');
        for (const item of items) {
            observer.observe(item);
        }
    }
}

const formatter = new Intl.NumberFormat('de', {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
});

const duration = 3500;

/**
 * @param {HTMLElement} element
 */
function initCounter(element) {
    const targetValue = parseInt(element.dataset.value);
    const valueEl = element.querySelector('.counter-item-value');

    let startTs = null;

    /**
     * @param {number} ts
     */
    const run = ts => {
        if (startTs === null) {
            startTs = ts;
        }

        const diff = ts - startTs;
        const progress = diff / duration;


        valueEl.innerText = formatter.format(easeInOutCubic(progress) * targetValue);

        if (progress >= 1) {
            return;
        }

        requestAnimationFrame(run);
    };

    requestAnimationFrame(run);
}

/**
 * @param {number} x
 * @returns {number}
 */
function easeInOutCubic(x) {
    return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
}